import { useState, useEffect } from 'react';
import { fetchAPI, UrlParams } from '../services/strapi';

function mapResponse(result: any, urlPrefix = "") {
  const dateList = `${result.attributes.promulgation_date}`.split('-');
  return {
    title: result.attributes.title,
    author: result.attributes.author,
    date: dateList.length === 3? `${dateList[2]}/${dateList[1]}/${dateList[0]}` : result.attributes.promulgation_date,
    pdf_url: result.attributes.file_path
  };
}
export type Search = {
  search_text?: string;
  initialDate?: string;
  finalDate?: string;
  index?: string;
  type?: string;
}

function mountFilter(array: any[], field: string | undefined | null, fieldTitle: string, operator: string = "$containsi") {
  if(field) {
    let filter: any = {};
    filter[fieldTitle] = {};
    filter[fieldTitle][operator] = field;

    array.push(filter);
  }
}

function mountCaseSensitiveFilter(array: any[], field: string | undefined | null, fieldTitle: string, operator: string = "$containsi") {
  if(field) {
    const tempArray: any[] = [];
    mountFilter(tempArray, field, fieldTitle, operator);
    mountFilter(tempArray, `${field}`.toUpperCase(), fieldTitle, operator);
    mountFilter(tempArray, `${field}`.toLowerCase(), fieldTitle, operator);

    array.push({
      $or: tempArray
    })
  }
}

function mapFilter(search: Search) {
  let filters: any = {};
  
  let or: any[] = [];
  if(search.search_text) {

    mountCaseSensitiveFilter(or, search.search_text, 'search_text');
    mountCaseSensitiveFilter(or, search.search_text, 'title');
    mountCaseSensitiveFilter(or, search.search_text, 'author');
    mountCaseSensitiveFilter(or, search.search_text, 'index');
    mountCaseSensitiveFilter(or, search.search_text, 'type');

    filters.$or = or;
  }

  let and: any[] = []

  mountFilter(and, search.initialDate, 'promulgation_date', '$gte');
  mountFilter(and, search.finalDate, 'promulgation_date', '$lte');
  
  mountCaseSensitiveFilter(and, search.index, 'index');

  //mountFilter(and, search.type, 'type', '$eq');
  if(search.type) {
    const type_or: any[] = [];
    mapInitialSearch(`${search.type}`, type_or);
    and.push({
      $or: type_or
    })
  }

  filters.$and = and;

  return filters
}

export function mapInitialSearch(initSearch: string, array: any[]|null = null) {
  switch (initSearch) {
    case "constituicao":
      array && mountCaseSensitiveFilter(array, "Constituição", 'type')
      return "Constituição"
    case "tratados":
      array && mountFilter(array, "Tratados", 'type')
      array && mountFilter(array, "Tratado", 'type')
      return "Tratados"
    case "leis-federais":
      array && mountFilter(array, "Lei Federal", 'type')
      array && mountFilter(array, "Leis Federais", 'type')
      return "Lei Federal"
    case "lei-complementar":
      array && mountFilter(array, "Lei Complementar", 'type')
      array && mountFilter(array, "Leis Complementares", 'type')
      return "Lei Complementar"
    case "medida-provisoria":
      array && mountCaseSensitiveFilter(array, "Medida Provisória", 'type')
      array && mountCaseSensitiveFilter(array, "Medidas Provisórias", 'type')
      return "Medida Provisória"
    case "decretos":
      array && mountFilter(array, "Decreto", 'type')
      array && mountFilter(array, "Decretos", 'type')
      return "Decretos"
    case "pl-senado":
      array && mountFilter(array, "PL no Senado", 'type')
      return "PL no Senado"
    case "pl-camara":
      array && mountCaseSensitiveFilter(array, "PL na Câmara", 'type')
      return "PL na Câmara"
    case "consultas-publicas":
      array && mountCaseSensitiveFilter(array, "Consulta Pública", 'type')
      array && mountCaseSensitiveFilter(array, "Consultas Públicas", 'type')
      return "Consulta Pública"
    case "outros":
      array && mountFilter(array, "Outro", 'type')
      array && mountFilter(array, "Outros", 'type')
      return "Outros"
    default:
      return ""
  }
}

export type Response = {
  results: any[],
  pagination: {
    page: number,
    pageSize: number,
    pageCount: number,
    total: number
	}
}

export const orderObjects = [
  {
    frontValue: 'Mais Recentes',
    backValue: ['promulgation_date:desc', 'title:desc']
  },
  {
    frontValue: 'Mais Antigas',
    backValue: ['promulgation_date:asc', 'title:asc']
  },
  {
    frontValue: 'Alfabética A - Z',
    backValue: ['title:asc', 'promulgation_date:asc']
  },
  {
    frontValue: 'Alfabética Z - A',
    backValue: ['title:desc', 'promulgation_date:desc']
  }
]

export function useNormas(initialSearch: string = ''): Response {
  const initialData: Response = {
    results: [], 
    pagination: {
      page: -1,
      pageCount: -1,
      pageSize: -1,
      total: -1
    }
  }
  const [data, setData] = useState<Response>(initialData);
  
  async function fetchData() {
    let query: UrlParams = {
      populate: "*",
      pagination: {
        page: 1,
        pageSize: 10
      },
      sort: ['promulgation_date:desc', 'title:desc'],
    };

    if (mapInitialSearch(initialSearch)) {
      let or: any[] = [];
      mapInitialSearch(initialSearch, or);
      query.filters = {
        $or: or
      }
    }

    setData(await makeRequest(query));
  }

  useEffect(() => {
    //if(data?.results?.length) return;
    fetchData();
  }, [data.pagination.page, initialSearch]); // eslint-disable-line react-hooks/exhaustive-deps

  return data;
};

export async function getNormas(search: Search | null = null, page: number = 1, order: string[] = orderObjects[0].backValue): Promise<Response> {
  let query: UrlParams = {
    populate: "*",
    pagination: {
      page: page,
      pageSize: 10
    },
    sort: order,
  };

  if(search) {
    query.filters = mapFilter(search);
  }
  return await makeRequest(query);
}


async function makeRequest(query: UrlParams): Promise<Response> {
  const response = await fetchAPI("/normas", query);
    return {
      results: response.data.map((item: any) => mapResponse(item)),
      pagination: response.meta.pagination
    };
}